import { ZonedDateTime } from '@internationalized/date';
import {
  TrailerSortOption,
  TrailerStatus,
} from '@rematter/frontend-lib-api-client';

import { TrailerRecord } from '~/modules/transportation/types';
import { createQueryHook } from '~/shared/providers/api';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const useTrailersQuery = createQueryHook(
  'transportation.trailers',
  (params: {
    ids?: string[];
    status?: TrailerStatus;
    licensePlate?: string;
    minCapacity?: number;
    maxCapacity?: number;
    lastUpdatedAt?: ZonedDateTime;
    searchTerm?: string;
    limit?: number;
    offset?: number;
    sorting?: TrailerSortOption[];
  }) => ({
    trailers: {
      __args: {
        filter: {
          ids: params.ids,
          status: params.status ? [params.status] : undefined,
          licensePlate: params.licensePlate,
          minCapacity: params.minCapacity,
          maxCapacity: params.maxCapacity,
          lastUpdatedAt: params.lastUpdatedAt?.toAbsoluteString(),
          searchTerm: params.searchTerm,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        status: true,
        currentLocation: {
          latitude: true,
          longitude: true,
        },
        lastLocationTime: true,
        licensePlate: true,
        licensePlateExpiration: true,
        vin: true,
        capacity: true,
        country: true,
        state: true,
        notes: true,
        transportationType: {
          id: true,
          name: true,
        },
        facility: {
          id: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { trailers: TrailerRecord[]; total?: number } => ({
      trailers:
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data?.trailers?.entries?.map((trailer: any) => ({
          id: trailer.id,
          status: trailer.status,
          licensePlate: trailer.licensePlate,
          transportationType: trailer.transportationType,
          capacity: trailer.capacity,
          location: trailer.currentLocation ?? undefined,
          country: trailer.country,
          state: trailer.state,
          vin: trailer.vin ?? undefined,
          licensePlateExpiration: trailer.licensePlateExpiration,
          notes: trailer.notes ?? undefined,
          facilityId: trailer.facility.id,
          timestamps: {
            createdAt: parseZonedDateTime(trailer.timestamps.createdAt),
            updatedAt: parseZonedDateTime(trailer.timestamps.updatedAt),
          },
        })) || [],
      total: data?.trailers?.page?.total ?? undefined,
    }),
  },
);
